import { ClipboardCheckIcon } from 'lucide-react'

import { registerSplitViewContent } from '../../split-view.registry'

import type { AgentReportData } from './agent-report.interface'
import { AgentReportContent } from './agent-report-content.molecule'
import { isAgentReportData } from './agent-report-validators.helper'

export const registerAgentReportContent = (): void => {
  registerSplitViewContent<AgentReportData>({
    type: 'agent-report',
    title: 'Agent Report',
    subtitle: (data) => data.agentName,
    icon: ClipboardCheckIcon,
    component: AgentReportContent,
    isValidData: isAgentReportData,
  })
}
